import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";

import logo from "../assets/logo.png";

/** The signed-in header: brand, sections, and a profile menu with sign-out. */
export function AppHeader({ email, onSignOut }: { email: string | null; onSignOut: () => void }) {
  const [open, setOpen] = useState(false);
  const menu = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (!menu.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <header className="bar">
      <Link to="/" className="brand"><img src={logo} alt="" />Botherlog</Link>
      <nav>
        <NavLink to="/diary">Diary</NavLink>
        <NavLink to="/devices">Devices</NavLink>
      </nav>
      <div className="profile" ref={menu}>
        <button className="avatar" aria-label="Account" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
            <circle cx="12" cy="8.5" r="3.6" />
            <path d="M4.8 19.5c1.3-3.4 4-5.1 7.2-5.1s5.9 1.7 7.2 5.1" strokeLinecap="round" />
          </svg>
        </button>
        {open && (
          <div className="menu" role="menu">
            {email && <div className="menu-email">{email}</div>}
            <button role="menuitem" onClick={onSignOut}>Sign out</button>
          </div>
        )}
      </div>
    </header>
  );
}
